import { Button, HStack } from '@chakra-ui/react';
import React, { FC } from 'react';

import s from './QuickAmountButtons.module.scss';

interface Props {
  onUpdate: (val: string) => void;
  balance: number | undefined;
  amount?: number | string;
}

export const QuickAmountButtons: FC<Props> = ({
  balance,
  onUpdate,
  amount
}) => {
  function renderButton(label: string, value: number, transparent?: boolean) {
    const isActive = amount && balance ? balance * value === +amount : false;

    if (transparent) {
      return (
        <Button
          variant="transparent"
          w="100%"
          color={isActive ? 'green.1' : 'gray.1'}
          bg="transparent"
          disabled={!balance}
          onClick={() => {
            if (balance !== undefined) {
              onUpdate((balance * value).toString());
            }
          }}
        >
          {label}
        </Button>
      );
    }

    return (
      <Button
        variant="toggle"
        w="100%"
        color={isActive ? 'green.1' : 'gray.1'}
        bg={isActive ? 'gray.5' : '#171816'}
        disabled={!balance}
        onClick={() => {
          if (balance !== undefined) {
            onUpdate((balance * value).toString());
          }
        }}
      >
        {label}
      </Button>
    );
  }

  return (
    <HStack w="100%" mt="8px">
      <div className={s.wrapper}>
        {renderButton('25%', 0.25)}
        {renderButton('50%', 0.5)}
        {renderButton('75%', 0.75)}
      </div>
      {renderButton('MAX', 1, true)}
    </HStack>
  );
};
